
const EditableMathExample = ({ placeholder = "Enter your question here", questionBody, setQuestionBody, disabled }) => {

  const handleTextAreaChange = (event) => {

    setQuestionBody(event.target.value);
  };
  return (
    <textarea
      required
      disabled={disabled}
      onChange={handleTextAreaChange}
      placeholder={placeholder} className="form-control text-lg" rows="5"
      value={questionBody}
    >
    </textarea>
  )
}

export default EditableMathExample;